<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    title="重置密码"
    :enableDrag="true"
    width="500px"
    @close="cancel">
    <dynamic-form :formConfig="formConfig" v-model="form" @submit="doSubmit" @cancelForm="cancel" ref="pageForm"></dynamic-form>
  </drag-dialog>
</template>

<script>
import { reset } from "@/api/user";
import DragDialog from "@/components/DragDialog";
import "@/components/dynamic-form";

export default {
  components: {
    DragDialog
  },
  props: {
    supThis: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      form: {},
      formConfig: {
        formItemList: [
          {
            key: "password",
            label: "新密码",
            type: "password",
            span: 24,
            value: "",
            placeholder: "请输入密码",
              rules: [{required: true, message: "不能为空", trigger: "blur"}]
          },
          {
            key: "newPassword",
            label: "确认密码",
            type: "password",
            span: 24,
            value: "",
            placeholder: "请确认密码",
              rules: [
                  {required: true, message: "不能为空", trigger: "blur"},
                  { validator: (rule, value, callback) => {
                      if (value !== this.form.password) {
                              callback(new Error('两次输入密码不一致!'));
                          } else {
                              callback();
                          }
                  }, trigger: 'blur' }
              ]
          }
        ]
      }
    };
  },
  methods: {
    cancel() {
      this.resetForm();
    },
    doSubmit(val) {
        reset(val).then(() => {
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500
          });
            this.resetForm();
        });
    },
    resetForm() {
      this.dialog = false;
      this.$refs.pageForm.resetForm();
    }
  }
};
</script>
